import React from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { SparklesIcon, ExpandIcon, PlayCircleIcon, ImageIcon, VideoIcon, CheckIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function DealerCreativeDashboard() {
  const navigate = useNavigate();
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1564">
      <Sidebar data-id="element-1565" />
      <main className="flex-1" data-id="element-1566">
        <Header data-id="element-1567" />
        <div className="px-6 py-8" data-id="element-1568">
          <div className="max-w-6xl mx-auto" data-id="element-1569">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1570">
              Creative Customizer
            </h1>
            <p className="text-gray-600 mb-8" data-id="element-1571">
              Create professional, brand-compliant creatives in minutes
            </p>

            <div className="grid grid-cols-3 gap-6" data-id="element-1572">
              {/* AI Creative Generator */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-1573">
                <div className="p-6" data-id="element-1574">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-1575">
                    <SparklesIcon className="text-blue-600" size={32} data-id="element-1576" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-1577">
                    AI Creative Generator
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-1578">
                    Create brand-compliant creatives from scratch with
                    AI-powered image generation
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-1579">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1580">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1581" />
                      <span data-id="element-1582">Generate static images</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1583">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1584" />
                      <span data-id="element-1585">Multiple format outputs (1:1, 9:16, 16:9)</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1586">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1587" />
                      <span data-id="element-1588">AI-powered backgrounds and compositions</span>
                    </div>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6" data-id="element-1589">
                    <p className="text-xs text-blue-800" data-id="element-1590">
                      <strong data-id="element-1591">Output:</strong> Image and/or Video
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/ai-generator/step-1')} className="w-full bg-blue-500 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-600 transition-colors" data-id="element-1592">
                    Start Creating
                  </button>
                </div>
              </div>

              {/* Creative Resizer */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-1593">
                <div className="p-6" data-id="element-1594">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6" data-id="element-1595">
                    <ExpandIcon className="text-purple-600" size={32} data-id="element-1596" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-1597">
                    Creative Resizer
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-1598">
                    Adapt existing creatives to different platform formats with
                    AI-powered resizing
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-1599">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1600">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1601" />
                      <span data-id="element-1602">Smart crop with focal point preservation</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1603">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1604" />
                      <span data-id="element-1605">Intelligent expansion to fill space</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1606">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1607" />
                      <span data-id="element-1608">Multiple format outputs instantly</span>
                    </div>
                  </div>

                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mb-6" data-id="element-1609">
                    <p className="text-xs text-purple-800" data-id="element-1610">
                      <strong data-id="element-1611">Output:</strong> Multiple format versions
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/resizer/step-1')} className="w-full bg-purple-500 text-white px-6 py-3 rounded-md font-medium hover:bg-purple-600 transition-colors" data-id="element-1612">
                    Resize Creative
                  </button>
                </div>
              </div>

              {/* Image to Video Generator */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-1613">
                <div className="p-6" data-id="element-1614">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-1615">
                    <PlayCircleIcon className="text-green-600" size={32} data-id="element-1616" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-1617">
                    Image to Video
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-1618">
                    Transform static product images into professional video ads
                    with AI-powered motion
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-1619">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1620">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1621" />
                      <span data-id="element-1622">Convert images to 4-8 second videos</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1623">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1624" />
                      <span data-id="element-1625">AI-powered motion and camera effects</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-1626">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-1627" />
                      <span data-id="element-1628">Maintains exact product design</span>
                    </div>
                  </div>

                  <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-6" data-id="element-1629">
                    <p className="text-xs text-green-800" data-id="element-1630">
                      <strong data-id="element-1631">Output:</strong> Professional video ad
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/video-generator/upload')} className="w-full bg-green-500 text-white px-6 py-3 rounded-md font-medium hover:bg-green-600 transition-colors" data-id="element-1632">
                    Generate Video
                  </button>
                </div>
              </div>
            </div>

            {/* Benefits Section */}
            <div className="mt-12 bg-white rounded-lg border border-gray-200 p-8" data-id="element-1633">
              <h3 className="text-lg font-semibold text-gray-800 mb-6 text-center" data-id="element-1634">
                Why Use Creative Customizer?
              </h3>
              <div className="grid grid-cols-3 gap-8" data-id="element-1635">
                <div className="text-center" data-id="element-1636">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1637">
                    <CheckIcon className="text-blue-600" size={24} data-id="element-1638" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-1639">
                    Brand Compliant
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1640">
                    All creatives follow approved brand guidelines automatically
                  </p>
                </div>
                <div className="text-center" data-id="element-1641">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1642">
                    <SparklesIcon className="text-purple-600" size={24} data-id="element-1643" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-1644">
                    Zero Design Skills
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1645">
                    Pre-set templates and animations make it easy for anyone
                  </p>
                </div>
                <div className="text-center" data-id="element-1646">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1647">
                    <VideoIcon className="text-green-600" size={24} data-id="element-1648" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-1649">
                    Professional Quality
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-1650">
                    Ad-like motion and transitions in minutes, not days
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}